import { Directive, HostListener, ElementRef, OnInit, AfterViewInit, SimpleChanges, Input, Renderer } from "@angular/core";
import { CurrencyPipe } from "./currency.pipe";

@Directive(
    {
        selector: "[CurrencyFormatter]"
    }
)
export class CurrencyFormatterDirective implements OnInit {

    private el: any;
    fractionSize: number
    @Input('options') options;
    constructor(
        private elementRef: ElementRef,
        private currencyPipe: CurrencyPipe
    ) {
        this.el = this.elementRef.nativeElement;
    }

    ngOnInit() {
        //console.log('Iniciou', this.el.value)
        setTimeout(() => {
            //console.log(this.options)
            this.fractionSize = JSON.parse(JSON.stringify(this.options)).fractionSize
        }, 200)
    }

    @HostListener('change')
    ngOnChanges(changes: SimpleChanges) {
        //console.log('Alterou Valor', changes.options.currentValue.value)
        // if (changes.options.currentValue.value) {
        //     this.el.value.replace('.', ',')
        // }
    }

    // @HostListener("change", ["$event.target.value", "$event"])
    // onChange(value, event) {
    //     //this.elementRef.nativeElement.value = this.formatcurrencypipe.parse(value);
    //     console.log('change')
    //     this.el.value = this.currencyPipe.transform(this.el.value.replace('.', ','), this.fractionSize)
    // }

    // @HostListener('change')
    // ngOnChanges(changes: SimpleChanges) {
    //     if (!this.elementLoad) {
    //         if (changes.options.currentValue.value) {
    //             console.log(changes.options.currentValue.value);
    //             this.el.value = this.currencyPipe.transform(changes.options.currentValue.value, this.fractionSize)
    //             this.elementLoad = true;
    //         }
    //     }
    // }

    @HostListener("focus", ["$event.target.value"])
    onFocus(value) {
        //console.log('Recebeu Foco', this.el.value)
        this.el.value = this.currencyPipe.parse(value, this.fractionSize); // opossite of transform        
        this.el.select()
    }

    @HostListener("blur", ["$event.target.value"])
    onBlur(value) {
        //console.log('Perdeu Foco', this.el.value)
        this.el.value = this.currencyPipe.transform(value, this.fractionSize)
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(event) {

        let e = <KeyboardEvent>event;

        if (e.keyCode == 190) {
            e.preventDefault();
        }

        if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
            // Allow: Ctrl+A
            (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+C
            (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+V
            (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
            // Allow: Ctrl+X
            (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
            // Allow: home, end, left, right
            (e.keyCode >= 35 && e.keyCode <= 39)) {
            // let it happen, don't do anything
            return;
        }

        if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

    }

}